import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import GeneralExpense from "../components/generalexpense.jsx";
import Footer from "../components/footer.jsx";

function GeneralExpensepage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <GeneralExpense/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default GeneralExpensepage;
